import PropTypes from 'prop-types';

import Alert from '#globalComponents/Alert/Alert';
import Select from '#globalComponents/Forms/Select';

const LABEL_CLASS = 'block text-xs font-semibold uppercase tracking-wide text-bgBase-800 mb-1';

const PipelineStageFields = ({ selection }) => {
	const { pipelines, stages, isLoading, pipelineId, setPipelineId, stageId, setStageId } = selection;

	if (isLoading) return <p className="text-bgBase-800 text-sm">Pipelines werden geladen …</p>;

	if (pipelines.length === 0) {
		return (
			<Alert tone="caution">
				Sie haben noch keine Pipeline angelegt. Öffnen Sie zuerst das CRM und legen Sie eine Pipeline an.
			</Alert>
		);
	}

	return (
		<div className="space-y-4">
			<div>
				<label className={LABEL_CLASS}>Pipeline</label>
				<Select value={pipelineId} onChange={(e) => setPipelineId(e.target.value)}>
					{pipelines.map((p) => (
						<option key={p.id} value={p.id}>
							{p.name}
							{p.isDefault ? ' (Standard)' : ''}
						</option>
					))}
				</Select>
			</div>
			<div>
				<label className={LABEL_CLASS}>Stage</label>
				<Select value={stageId} onChange={(e) => setStageId(e.target.value)} disabled={stages.length === 0}>
					{stages.map((s) => (
						<option key={s.id} value={s.id}>
							{s.name}
						</option>
					))}
				</Select>
			</div>
		</div>
	);
};

PipelineStageFields.propTypes = {
	selection: PropTypes.shape({
		pipelines: PropTypes.array.isRequired,
		stages: PropTypes.array.isRequired,
		isLoading: PropTypes.bool,
		pipelineId: PropTypes.string,
		setPipelineId: PropTypes.func.isRequired,
		stageId: PropTypes.string,
		setStageId: PropTypes.func.isRequired,
	}).isRequired,
};

export default PipelineStageFields;
